var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEthLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "#8C8C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2445 10.1818L28.0056 10.9936V34.5519L28.2445 34.7903L39.18 28.3264L28.2445 10.1818Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2446 10.1818L17.3091 28.3264L28.2446 34.7904V23.3559V10.1818Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2445 36.8608L28.1099 37.0249V45.4169L28.2445 45.8101L39.1865 30.4001L28.2445 36.8608Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2446 45.81V36.8607L17.3091 30.4L28.2446 45.81Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2445 34.7903L39.1798 28.3264L28.2445 23.356V34.7903Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3091 28.3264L28.2445 34.7903V23.356L17.3091 28.3264Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEthLg);
export default __webpack_public_path__ + "static/media/icon-eth-lg.9ed9c4d3.svg";
export { ForwardRef as ReactComponent };